import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';

const TextFilterField = ({ label, name, value, onBlurChange, transform, type, autoComplete, inputProps, style }) => {
    const [local, setLocal] = useState(value || '');

    useEffect(() => { setLocal(value || ''); }, [value]);

    const handleChange = (e) => {
        const raw = e.target.value;
        setLocal(transform ? transform(raw) : raw);
    };

    const handleBlur = () => {
        onBlurChange(local);
    };

    return (
        <TextField
            style={style || { background: 'white' }}
            fullWidth
            variant="outlined"
            label={label}
            name={name}
            type={type}
            autoComplete={autoComplete}
            value={local}
            onChange={handleChange}
            onBlur={handleBlur}
            inputProps={inputProps}
        />
    );
};

export default TextFilterField;
